import React from 'react';
import './noticias.css';

const Noticias = () => {

  return (

    <section id="noticias" className="noticias">
        
        <div className="rectangulo"></div>

        <div className="contenido-seccion">

            <h2>Noticias</h2>

            <div className="container-tipo">
                <h1 className="tipo-noticia">Entérate Pradera:</h1>
            </div>

            <div className="noticia-seccion-reverse">
                
                <div className="col-1-1">

                    <img src="./img/noticiaPradera6.jpeg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>"Fallecimiento del Sr. Hugo Horacio Ramírez Burgos"</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            Lamentamos informar el asesinato del pradereño Hugo Horacio Ramírez Burgos.
                            Nuestras condolencias para sus familiales y amigos.
                            Pedimos a Dios les consuele y fortalezca en estos momentos.
                            Para Hugo Horacio, nuestra oración, recuerdo y cariño por siempre.
                        </p>

                        <a> 
                            Ubicación: Pradera
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/watch/?v=211560725028712&extid=CL-UNK-UNK-UNK-IOS_GK0T-GK1C&mibextid=l2pjGR&ref=sharing"> 
                            Mas información
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>

                </div>

            </div>

            <div className="noticia-seccion">
                
                <div className="col-1 izq">

                    <div className="titular">
                        
                        <h3>"Fallecimiento del Sr. Argemiro Rodíguez Vera"</h3>

                    </div>          

                    <div className="contenido-noticia">
                        
                        <p>
                            Nuestras condolencias para sus familiares y amigos. 
                            Pedimos a Dios les consuele y fortalezca en estos momentos. 
                            Para Don Argemiro, nuestra oración, recuerdo y cariño por siempre
                        </p>

                        <a> 
                            Ubicación: Pradera
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/100066718834054/posts/pfbid0sWKku3GBmTwHX9cVzwdp5jMuUM9pqCRCgTJqLyh7HEmZ2bfDQ9JPAREsbbaB44Fl/?mibextid=DcJ9fc"> 
                            Mas información
                        </a>

                        <div className="conectori">

                            <div className="circuloi"></div>

                        </div>

                    </div>   

                </div>

                <div className="col-2">

                    <img src="./img/noticiaPradera5.jpeg" alt="imagen.png"></img>

                </div>

            </div>

            <div className="noticia-seccion-reverse">
                
                <div className="col-1-1">

                    <img src="./img/noticiaPradera4.jpeg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>"#AyúdanosACompartir"</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            
                        </p>

                        <a> 
                            Ubicación: Pradera
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/watch/?v=210466501801780&extid=CL-UNK-UNK-UNK-IOS_GK0T-GK1C&mibextid=2Rb1fB&ref=sharing"> 
                            Mas información
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>

                </div>

            </div>

            <div className="noticia-seccion">
                
                <div className="col-1 izq">

                    <div className="titular">
                        
                        <h3>"Nos piden ayuda para encontrar a Franky Díaz Salazar"</h3>

                    </div>          

                    <div className="contenido-noticia">
                        
                        <p>
                            Este joven pradereño, está desaparecido desde el día 29 de mayo,  salió tipo 8 de la mañana de  su  casa en el  barrio  Serrezuela y hasta el momento su familia no sabe de su paradero. 
                            “Por favor su familia  los espera  con bien en casa y muchas  gracias por  su atención se les agradeceria  cualquier información Dios Los bendiga 🙏 por favor difundir La información”
                        </p>

                        <a> 
                            Ubicación: Pradera
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/100066718834054/posts/pfbid0Nee51LYGkBUkLgYi1Sd1Z5BeZzEjWDQRpdaR947NEjuWvH6KkDwvVoL6EDDob8gBl/?mibextid=cr9u03"> 
                            Mas información
                        </a>

                        <div className="conectori">

                            <div className="circuloi"></div>

                        </div>

                    </div>   

                </div>

                <div className="col-2">

                    <img src="./img/noticiaPradera3.jpeg" alt="imagen.png"></img>

                </div>

            </div>

            <div className="noticia-seccion-reverse">
                
                <div className="col-1-1">

                    <img src="./img/noticiaPradera2.jpeg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>"580 personas se benefician de jornada de salud en el corregimiento “El Arenal”"</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            
                        </p>

                        <a> 
                            Ubicación: Pradera
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/100066718834054/posts/pfbid036EDY4fLXQgm889ADkybF5DNicHYkTvSBuSHBksNKcsVcHkDeodp94KXqMMqUkGHFl/?mibextid=cr9u03"> 
                            Mas información
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>

                </div>

            </div>

            <div className="noticia-seccion">
                
                <div className="col-1 izq">

                    <div className="titular">
                        
                        <h3>"La Red Informativa Entérate Pradera y Valle, se une al Informativo Colombia Hoy, Radio y TV"</h3>

                    </div>          

                    <div className="contenido-noticia">
                        
                        <p>
                            Un espacio informativo que tiene como protagonista, a la gente, la actualidad del país, sus regiones y toda la información del Gobierno.
                            #EntératePraderayValle #SomosRegióm #SomosPaís
                        </p>

                        <a> 
                            Ubicación: Pradera
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/100066718834054/posts/588265073407449/?mibextid=afzh1R"> 
                            Mas información
                        </a>

                        <div className="conectori">

                            <div className="circuloi"></div>

                        </div>

                    </div>   

                </div>

                <div className="col-2">

                    <img src="./img/noticiaPradera1.jpeg" alt="imagen.png"></img>

                </div>

            </div>

            <div className="noticia-seccion-reverse">
                
                <div className="col-1">

                    <img src="./img/noticia8.jpeg" alt="imagen.png"></img>
                    <img src="./img/noticia8-2.jpeg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>"Parrocos de nuestro Municipio"</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            Párrocos de nuestro municipio, desde el muy recordado Padre Manuel José Ramirez🙏
                            1. Pbro. Manuel José Ramírez Q.E.P.D.                                    2. Pbro. Luis Enrique Restrepo Restrepo Q.E.P.D.                  
                            3. Pbro. José Uldarico Giraldo  Gómez  Q.E.P.D.                                  
                            4. Pbro. Jorge Fierro García                          5. Pbro.  Camilo Villa
                            6. Pbro. Semey Lucumí  Holguín.                                    7. Pbro. Luis Eduardo Bejarano Barona                            8. Jhon Henry Jaramillo Duque
                        </p>


                        <a> 
                            Fecha: 18 / Enero / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/1719997704942461/posts/pfbid07pY3i5qoYjcgRH1TXQzbB3PsEmRPCP3nrMEJKjmcsyDKiezoHbw7GGfP6Tyn2ym4l/?mibextid=cr9u03"> 
                            Mas información
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>
                    

                </div>

            </div>

            {/*<div className="noticia-seccion-reverse">
                
                <div className="col-1">

                    <img src="./img/cohete.jpg" alt="imagen.png"></img>
                    <img src="./img/cohete.jpg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>Titular "Ejemplo":</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own 
                            Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own 
                            Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own 
                        </p>

                        <a> 
                            Ubicación: Lomitas
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 16 / Enero / 2023
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>
                    

                </div>

            </div>*/}

            <div className="separador"></div>

            <div className="container-tipo">
                <h1 className="tipo-noticia">Entérate Valle:</h1>
            </div>

            <div className="noticia-seccion-reverse">
                
                <div className="col-1-1">

                    <img src="./img/noticiaValle63.jpeg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>"Lotería del Valle tendrá lanzamiento adicional de $20 millones"</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            Hoy miércoles 31 de mayo la Lotería del Valle tendrá lanzamiento adicional de $20 millones ‘Programa tus vacaciones’
                            Con un sorteo especial del bono ‘Programa tus vacaciones’, este miércoles 31 de mayo la Lotería del Valle llega con más oportunidades de ganar a los apostadores del país y del departamento...
                        </p>

                        <a> 
                            Ubicacíon: Valle del Cauca
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/watch/?v=204089622055730&extid=CL-UNK-UNK-UNK-IOS_GK0T-GK1C&mibextid=l2pjGR&ref=sharing"> 
                            Mas información
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>

                </div>

            </div>

            <div className="noticia-seccion">
                
                <div className="col-1 izq">

                    <div className="titular">
                        
                        <h3>"Detrás de Cámara"</h3>

                    </div>          

                    <div className="contenido-noticia">
                        
                        <p>
                            📢¡Muy pronto!
                            El nuevo programa para ti y tu familia, con el fin de que estés más cerca de los y las representantes que tú elegiste. #DetrásDeCámara
                        </p>

                        <a> 
                            Ubicación: Valle del Cauca
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/magaly.roldan1/videos/773134687745106/?idorvanity=501070710941700"> 
                            Mas información
                        </a>

                        <div className="conectori">

                            <div className="circuloi"></div>

                        </div>

                    </div>   

                </div>

                <div className="col-2">

                    <img src="./img/noticiaValle62.jpeg" alt="imagen.png"></img>

                </div>

            </div>

            <div className="noticia-seccion-reverse">
                
                <div className="col-1-1">

                    <img src="./img/noticiaValle61.jpeg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>"Banco de Alimentos Cali"</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            Nos unimos al Banco de Alimentos Cali para contribuir a la atención alimentaria de quienes más lo necesitan en el Valle y norte del Cauca. Conoce más aquí
                            #Compromisodesde1918 #CompromisoporColombia #CorazónDeCaña
                        </p>

                        <a> 
                            
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/riopailacastilla/videos/242834965015600"> 
                            Mas información
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>

                </div>

            </div>

            <div className="noticia-seccion">
                
                <div className="col-1 izq">

                    <div className="titular">
                        
                        <h3>"Impuesto Automotor 2023"</h3>

                    </div>          

                    <div className="contenido-noticia">
                        
                        <p>
                            Propietarios de vehículos con placas entre 334 y 666 hasta este 31 de mayo pueden pagar el Impuesto Automotor 2023
                            Mañana 31 de mayo es el último día para que los propietarios de vehículos matriculados en el Valle del Cauca, cuyas placas estén entre el 334 y el 666, paguen el Impuesto Automotor, sin sanciones ni intereses...
                        </p>

                        <a> 
                            Ubicación: Valle del Cauca
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/100066718834054/posts/pfbid02C9FFVEDh1eVRpiopVqXR6dg9VWiKf42afV4EjNSRandBHLuCj7hq3BjM9HJ998V1l/?mibextid=DcJ9fc"> 
                            Mas información
                        </a>

                        <div className="conectori">

                            <div className="circuloi"></div>

                        </div>

                    </div>   

                </div>

                <div className="col-2">

                    <img src="./img/noticiaValle60.jpeg" alt="imagen.png"></img>

                </div>

            </div>

            <div className="noticia-seccion-reverse">
                
                <div className="col-1-1">

                    <img src="./img/noticiaValle2.jpeg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>"Colombia mayor"</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            A partir de mañana martes 30 de mayo inicia el pago del programa #ColombiaMayor y finaliza el próximo 13 de junio y se podrá disponer del recurso en los puntos de SuperGiros y aliados.
                        </p>

                        <a> 
                            
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 31 / Mayo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/groups/501070710941700/permalink/945502999831800/?mibextid=S66gvF"> 
                            Mas información
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>

                </div>

            </div>

            <div className="noticia-seccion-reverse">
                
                <div className="col-1-1">

                    <img src="./img/noticiaValle59.jpeg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>"Tractomula Volcada en la Vía el Hortigal e ingenio Cauca"</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            
                        </p>

                        <a> 
                            Ubicación: El Hortigal y el ingenio Cauca
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 1 / Marzo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/magaly.roldan1/videos/884790855929460/?idorvanity=501070710941700"> 
                            Mas información
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>

                </div>

            </div>

            <div className="noticia-seccion">
                
                <div className="col-1 izq">

                    <div className="titular">
                        
                        <h3>"Homicidio en Cali"</h3>

                    </div>          

                    <div className="contenido-noticia">
                        
                        <p>
                            
                        </p>

                        <a> 
                            Ubicación: Cali
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 1 / Marzo / 2023
                        </a>
                        <br></br>
                        <a href="https://www.facebook.com/magaly.roldan1/videos/907069533841462/?idorvanity=501070710941700"> 
                            Mas información
                        </a>

                        <div className="conectori">

                            <div className="circuloi"></div>

                        </div>

                    </div>   

                </div>

                <div className="col-2">

                    <img src="./img/noticiaValle58.jpeg" alt="imagen.png"></img>

                </div>

            </div>

            {/*<div className="separador"></div>

            <div className="container-tipo">
                <h1 className="tipo-noticia">Noticias Colombia:</h1>
            </div>

            <div className="noticia-seccion">
                
                <div className="col-1 izq">

                    <div className="titular">
                        
                        <h3>Titular "Ejemplo":</h3>

                    </div>          

                    <div className="contenido-noticia">
                        
                        <p>
                            Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own 
                            Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own 
                            Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own 
                        </p>

                        <a> 
                            Ubicación: Lomitas
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 16 / Enero / 2023
                        </a>

                        <div className="conectori">

                            <div className="circuloi"></div>

                        </div>

                    </div>   

                </div>

                <div className="col-2">

                    <img src="./img/cohete.jpg" alt="imagen.png"></img>

                </div>

            </div>

            <div className="noticia-seccion-reverse">
                
                <div className="col-1">

                    <img src="./img/cohete.jpg" alt="imagen.png"></img>
                    <img src="./img/cohete.jpg" alt="imagen.png"></img>

                </div>

                <div className="col-2 izq">

                    <div className="titular">
                        
                        <h3>Titular "Ejemplo":</h3>

                    </div>  

                    <div className="contenido-noticia">
                        
                        <p>
                            Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own 
                            Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own 
                            Esto es un ejemplo de una noticia para saber cuanto puede ser el tamaño y todo lo ecesario para ver i cabe en el espacio
                            skjdwnhcjeirco wirp kjqoi oeitp jwitiujdj2 utegflo ti witpvne jiwjejjsejin eiy2696,n wtte  own 
                        </p>

                        <a> 
                            Ubicación: Lomitas
                        </a>
                        <br></br>
                        <a> 
                            Fecha: 16 / Enero / 2023
                        </a>

                        <div className="conectord">

                            <div className="circulod"></div>

                        </div>

                    </div>
                    

                </div>
            
            </div>*/}

        </div>  

        

    </section>

  );

};

export default Noticias;